import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DataService, AnalyticsService, StorageService } from '../../_services';

@Component({
  selector: 'app-requestssummary',
  templateUrl: './requestssummary.component.html',
  styleUrls: ['./requestssummary.component.css']
})
export class RequestssummaryComponent implements OnInit {

  @Input('currentUser') currentUser: any;
  @Input('due') due: any;
  @Input() showCollections = false;
  platform_summary: any;
  loadingPS = false;
  showperformance = '';
  @Output() showDueLoansList = new EventEmitter();
  @Input('from_where') from_where = 'portfolio';
  @Input('group_id') group_id = 'portfolio';
  portfolio_summary:any;
  lender:any;
  constructor(private storageService: StorageService, private dataService: DataService, private analytics: AnalyticsService) { 
    this.lender = this.storageService.read<any>('platform');
  }

  ngOnInit() {
    this.runPlatformSummary();
    this.runPortfolioSummary();
  }
  sdl() {
    this.showDueLoansList.emit();
  }
  runPlatformSummary() {
    this.loadingPS = true;
    this.analytics.runPlatformEarnings(this.currentUser.token, this.from_where, this.group_id)
      .subscribe(data => {
        // //console.log(data);
        this.loadingPS = false;
        this.showperformance = 'yes';
        this.platform_summary = data;
        //this.dataService.portfolioPlatformSummaryLoaded.emit({platform_summary:data}); 
      });
  }
  runPortfolioSummary() {
    this.loadingPS = true;
    this.analytics.runRequestSummary(this.currentUser.token)
      .subscribe(data => {
        // //console.log(data);
        this.loadingPS = false; 
        this.portfolio_summary = data; 
      });
  }
  loadRecords(period){
    this.dataService.loadrequestrecords.emit({period: period});
  }
} 
